import tableOperation from '../common/table-operation'

const getPaginatedCallerIDs = function (state) {
  const { limit, currentPage, searchText = "" } = state.table

  const result = tableOperation.getPaginatedCollection({
    collection: [...state.callerIDs],
    paginationConfig: {
      limit: limit,
      page: currentPage,
      query: searchText,
    },
  })

  return result
}

export default getPaginatedCallerIDs
